import React from 'react';
import PropTypes from 'prop-types';
import { Box, Heading, PanelHeader, PanelFooter } from 'rebass';
import Button from '../../app/components/button';
import Content from '../../app/components/content';

const Success = ({ close }) => (
  <div>
    <PanelHeader
      color="greyLight"
      bg="greyExtraLight"
      px={4}
      py={3}
    >
      <Heading color="black">
        Thank you!
      </Heading>
    </PanelHeader>
    <Box px={4} py={4}>
      <Content>
        We&apos;ve received your inquiry and will be in touch within the{' '}
        <Content bold is="span">
          next business day
        </Content>.
      </Content>
    </Box>
    <PanelFooter
      color="greyLight"
      bg="greyExtraLight"
      px={4}
      py={3}
    >
      <Button
        type="submit"
        bg="grey"
        f={3}
        onClick={close}
      >
        Close
      </Button>
    </PanelFooter>
  </div>
);

Success.propTypes = {
  close: PropTypes.func.isRequired,
};

export default Success;



// WEBPACK FOOTER //
// ./src/Lead/success/index.js